module.exports = __webpack_public_path__ + "static/img/5-box.65764f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5-box.png
// module id = 3guH
// module chunks = 0